import { cn } from '@/lib/utils'

const range = (window) => window && `${window.start} ～ ${window.end}`

/** MON-93 范围名：全量口径叫全盘；根但按权限过滤过叫全部产品；其余为节点名 */
export const scopeName = (scope) => {
  if (scope.kind !== 'root') return scope.name
  return scope.full ? '全盘' : '全部产品'
}

const countriesText = (countries) => (countries ? `${countries.length} 国` : '全部国家')

/** 口径条：范围（收窄后）、截止日、花费基准、预测队列（MON-89 其余项移入术语抽屉「本页信息」） */
export function ScopeList({ data }) {
  const items = [
    ...(data.range.full ? [] : [['范围', `${scopeName(data.range)} · ${countriesText(data.range.countries)}`]]),
    ['数据截止日', data.asOf],
    ['花费基准', range(data.scope.spendWindow)],
    ['预测队列（D30 窗口）', range(data.scope.d30Window)],
  ]
  return (
    <ul className={cn('grid gap-x-6 gap-y-2 text-sm sm:grid-cols-2', items.length > 3 ? 'lg:grid-cols-4' : 'lg:grid-cols-3')}>
      {items.map(([label, value]) => (
        <li key={label} className="flex items-baseline gap-2">
          <span className="shrink-0 text-xs text-muted-foreground">{label}</span>
          <span className="font-medium tabular-nums">{value ?? '-'}</span>
        </li>
      ))}
    </ul>
  )
}

const snapshotText = (data) => {
  if (!data.range.full) return '收窄范围现算，不留档'
  return data.snapshot.persisted ? '已留档' : '数据沉淀期内，未留档，每次读取重算'
}

/** 术语抽屉末尾「本页信息」：权限与范围规则、最新可用日、实测安装月、revision 与留档状态 */
export const pageInfo = (data) => [
  ['权限', '按 pid × 国家格子过滤，不可读的格子不进本页任何数字。'],
  ['成熟倍数样本池', '本格样本不足退 pid 级时，样本池取该 pid 全部国家的队列，不随权限收窄。'],
  ['其他国家格子', '只在不筛国家、且其中全部成员国都可读时出现。'],
  ['最新可用日', data.latest],
  ['实测安装月', data.scope.actualMonths.join(' / ') || '无'],
  ['数据盘 revision', data.dashboardRevision],
  ['本页 revision', data.revision],
  ['留档状态', `${snapshotText(data)} · ${data.snapshot.createdAt}`],
]
